import styled from 'styled-components';
import { Color } from '../../theme/colors';

export const Link = styled.a`
  text-decoration: underline;
  color: ${Color.secondary};
`;
